import { useWorkshopArtifact } from "../api/useWorkshopArtifacts";
import { documentTag } from "../workshopOutputs";
import WorkshopOutputCard from "./WorkshopOutputCard";

type Props = {
  artifactId: string;
  fallbackTitle: string | null;
  onOpen?: (artifactId: string) => void;
};

/**
 * The document a turn made, as an output card in the chat. The reply after it
 * says what it is (approved text, creative-os-backend#117), so the card carries
 * only the kind (when the data has one), the version and the title.
 */
export default function CreatedArtifactPreviewCard({
  artifactId,
  fallbackTitle,
  onOpen,
}: Props) {
  const { data: artifact, isLoading } = useWorkshopArtifact(artifactId);
  const title = artifact?.title?.trim() || fallbackTitle?.trim() || "Untitled document";
  return (
    <WorkshopOutputCard
      tag={artifact ? documentTag(artifact.kind) : null}
      meta={artifact ? `V${artifact.version}` : null}
      title={title}
      loading={isLoading && !fallbackTitle}
      onOpen={onOpen ? () => onOpen(artifactId) : undefined}
      openLabel={`Open ${title}`}
    />
  );
}
